import { MainLayout } from '../../components/layouts/MainLayout.tsx';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { useChannelsService } from '../../hooks/useChannelsService.tsx';
import { useEffect, useState } from 'react';
import apiNet from '../../newApi/apiNet.ts';
import { IFavorite } from '../../interfaces/account/favorite/IFavorite.ts';
import { useModal } from '../../hooks/useModal.tsx';
import AccountFavoriteDetailsModalContent
    from '../../components/account/favorite/modals/AccountFavoriteDetailsModal.tsx';
import { useAppDispatch, useAppSelector } from '../../stores/store.ts';
import { accountFavoritesActions } from '../../components/account/favorite/accountFavoritesSlice.ts';

type TabItem = {
    label: string,
    isActive: boolean,
    searchType: string,
}

const initialTabs: TabItem[] = [
    {
        isActive: true,
        label: 'Programy',
        searchType: 'program',
    },
    {
        isActive: false,
        label: 'Wyszukiwania',
        searchType: 'search',
    },
];

const AccountFavoritesPage = () => {
    const { channels } = useChannelsService();
    const { showModal } = useModal();
    const [favorites, setFavorites] = useState<IFavorite[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [tabs, setTabs] = useState(initialTabs);
    const _dispatch = useAppDispatch();
    const favoritess = useAppSelector(state => state.favorites.items);

    const modalHeader = (name: string) =>
        <div>
            <p className={'text-neutral-400 font-medium'}>Ulubione</p>
            {/*<h1 className={"text-2xl"}>{name}</h1>*/}
            <h1 className={'text-2xl'}>{name}</h1>
        </div>;

    const handleOpenModal = (favorite: IFavorite) => {
        showModal(modalHeader(favorite.name), <AccountFavoriteDetailsModalContent channels={channels}
                                                                                  favorite={favorite} />);
    };

    function classNames(...classes: string[]) {
        return classes.filter(Boolean).join(' ');
    }

    const changeTab = (tab: TabItem) => {
        setTabs(prev =>
            prev.map(item => ({
                ...item,
                isActive: item.label === tab.label,
            })),
        );
    };

    useEffect(() => {
        // Pobierz dane po wejściu na widok
        const fetchFavorites = async () => {
            setIsLoading(true);
            try {
                const res = await apiNet.getFavorites();
                const data = res.data;
                console.log('Czy to na pewno tablica?', Array.isArray(data), data);
                _dispatch(accountFavoritesActions.updateAll({ favorites: data }));
                // setFavorites(data);
            } catch (error) {
                console.error('Błąd podczas pobierania danych:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchFavorites();
    }, [_dispatch]);

    return (
        <>
            <MainLayout contentPadding={'px-0 pb-4 pt-14 md:pt-0'}>
                <div className={'bg-neutral-900 pt-4'}>
                    <p className={'ml-4 text-neutral-400 text-md'}>Twoje konto</p>
                    <h1 className={'text-3xl ml-4'}>Ulubione</h1>
                    <div className={'w-full bg-neutral-800 h-0.5 my-5 mb-0'}></div>
                    {/*<div className={"flex gap-10"}>*/}
                    <nav aria-label="Tabs" className="-mb-px flex">

                        {tabs.map((tab) => (
                            <button
                                key={tab.label}
                                className={classNames(
                                    tab.isActive
                                        ? 'border-[#008DD2] text-[#008DD2]'
                                        : 'border-transparent text-neutral-400 hover:border-white/20 hover:text-neutral-300',
                                    'w-1/2 md:w-48 border-b-2 px-1 py-4 text-center text-sm font-medium transition',
                                )} onClick={() => changeTab(tab)}>
                                <p className={'px-2'}>{tab.label}</p>
                            </button>
                        ))}
                    </nav>
                    {/*</div>*/}
                </div>
                <div className={'w-full'}>
                    {favoritess.filter(item => item.type === tabs.find(item => item.isActive)?.searchType).map((favorite: IFavorite) =>
                        <button key={favorite.id}
                                onClick={() => handleOpenModal(favorite)}
                                className={'px-4 border-b border-neutral-700 py-3 flex items-center justify-between hover:bg-neutral-900/40 cursor-pointer transition w-full'}>
                            <p>{favorite.name}</p>
                            <ChevronRightIcon className={'w-5 h-5 text-[#008DD2]'} />
                        </button>,
                    )}
                </div>
            </MainLayout>
            {/*<AccountFavoriteDetailsModal channels={channels} name={"sdnsdn"}/>*/}
        </>
    );
};

export default AccountFavoritesPage;